import { Button } from "@mecha/design-components/dist/src/components/Elements/Button";
import CopyIcon from "../../../../assets/svg/CopyIcon";
import Logger from "../../../../libs/Logger";
import InfoCircleIcon from "../../../../assets/svg/InfoCircleIcon";
import { useStore } from "../../../../storeManager/stores";
import { copyToClipboard } from "../../../../utils/copyToClipboard";
import { observer } from "mobx-react";
import { ApiKeyStatus } from "../../../../config/constants";

const ApiKeyAdded = () => {
  const log = new Logger({
    module: "Settings",
    component: "ApiKeyAdded",
  });
  const {
    setApiKeyModal,
    setGenerateKeyModalStep,
    generatedAPIKeyData,
    fetchApiKeys,
  } = useStore().settingsStore;

  const { expiryDate, name, accessKeyId, accessKeySecret } =
    generatedAPIKeyData;

  const onClose = () => {
    setGenerateKeyModalStep(1);
    setApiKeyModal(false);
    fetchApiKeys();
  };

  return (
    <div className="mt-2">
      <div className="flex flex-col gap-5">
        <div>
          <p className="font-medium text-web-b5 dark:text-dark-n-500 text-light-n-500">
            API Key
          </p>
          <div className="mt-[6px] w-full px-3 py-[10px] dark:bg-dark-760 bg-light-760 rounded-md grid grid-cols-[4fr_1fr] gap-2 items-center">
            <div className=" overflow-x-auto mecha-scroll-2">
              <p
                className="text-web-b4 dark:text-dark-n-200 text-light-n-200"
                title={name}
              >
                {name}
              </p>
            </div>

            <p className="text-web-b5 dark:text-dark-n-500 text-light-n-500 __text-expiry-date-onsucess text-justify whitespace-nowrap">
              {generatedAPIKeyData["expiryDate"] === ApiKeyStatus.NO_EXPIRY
                ? "No Expiry"
                : `Expires on ${expiryDate}`}
            </p>
          </div>
        </div>
        <div>
          <p className="font-medium text-web-b5 dark:text-dark-n-500 text-light-n-500">
            API Key ID
          </p>
          <div className="mt-[6px]  w-full px-3 py-[10px] dark:bg-dark-760 bg-light-760 rounded-md flex flex-row items-center justify-between ">
            <p className=" text-web-b4 dark:text-dark-n-200 text-light-n-200 w-[90%] overflow-x-hidden">
              {accessKeyId}
            </p>
            <button
              className="h-full flex items-center __button-copy-api-key"
              onClick={() => copyToClipboard("API key", accessKeyId)}
            >
              <CopyIcon />
            </button>
          </div>
        </div>
      </div>
      <div className="border dark:border-neutral-110 my-5 w-full"></div>
      <p className="mt-5 font-medium text-web-b5 dark:text-dark-n-500 text-light-n-500">
        Key secret
      </p>
      <div className="w-full mt-[6px] px-3 py-[10px] dark:bg-dark-760 bg-light-760 rounded-md flex flex-row items-center justify-between ">
        <p className="text-web-b4 dark:text-dark-n-200 text-light-n-200 w-[90%] overflow-x-hidden mt-[6px] break-all">
          {accessKeySecret}
        </p>
        <button
          className="h-full flex items-center __button-copy-api-secret"
          onClick={() => copyToClipboard("API key secret", accessKeySecret)}
        >
          <CopyIcon />
        </button>
      </div>
      <div className="mt-5 py-[14px] px-4 rounded-lg dark:bg-dark-b-530 bg-light-b-530 dark:text-storm-dust-100 text-web-b5 font-medium flex flex-row items-start gap-2 text-[#33394E]">
        <div>
          <InfoCircleIcon className="w-6 h-6" />
        </div>
        Make sure to copy and save your personal access token now, as you will
        not be able to see this again
      </div>
      <div className="border dark:border-neutral-110 mt-5 w-full"></div>
      <span className="flex items-center justify-end mt-10 md:mt-20 relative  w-full">
        <div>
          <Button size="m" color="secondary-default" onClick={onClose}>
            Close
          </Button>
        </div>
      </span>
    </div>
  );
};

export default observer(ApiKeyAdded);
